import { type PlanBase, getPlansList } from '@/api/initial-state';
import planQueryBuilder from '@/helpers/planQueryBuilder';

type PlansState = {
  plans: PlanBase[];
  activePlanId: number;
};

const { getFrom, urlHasPlanAlias, hasBestPrice } = planQueryBuilder();

export const usePlansStore = defineStore('plans', {
  state(): PlansState {
    const plans = getPlansList();

    const initialPlan = getFrom(plans)
      .or(urlHasPlanAlias)
      .or(hasBestPrice)
      .get();

    return {
      plans: markRaw(plans),
      activePlanId: initialPlan['item-id'],
    };
  },

  getters: {
    activePlan(state): PlanBase {
      return state.plans.find(
        (item) => item['item-id'] === state.activePlanId,
      )!;
    },
  },

  actions: {
    setActivePlan(id: number) {
      this.activePlanId = id;
    },
  },
});
